$.initialisePrimaryNav = () => {
  document.addEventListener("DOMContentLoaded", function() {
  let primaryNavBar = document.querySelectorAll('.primary-nav');
  if(primaryNavBar.length) {
      document.activeElement.blur();
      //adjust height of mobile menu when url bar resizes
      function calcVH() {
        if(window.innerWidth < 1140) {
          var vH = Math.max( window.innerHeight || 0);
          document.querySelector(".primary-menu").setAttribute("style", "max-height:" + (vH - 150) + "px;");
        }
      }

      calcVH();
      window.addEventListener('onorientationchange', calcVH, true);
      $(window).smartresize(() => {
        calcVH();
      })

      //length of search bar
      function resizeSearchBar() {
        const navBarLength = primaryNavBar[0].offsetWidth;
        const navBarLengthFinal = navBarLength - 15 ;
        const searchBar = document.querySelector('.dropdown__container--search .dropdown');
        searchBar.style.width = navBarLengthFinal + "px";
      }

      resizeSearchBar();
      $(window).smartresize(() => {
        resizeSearchBar();
      })

      // desktop menu
      const menuItems = document.querySelectorAll('li.has-submenu');

      let timer = null;
      const hideSubmenus = () => {
        const openSubmenu = document.querySelector('.has-submenu.open');
        if (openSubmenu) {
          openSubmenu.classList.remove('open');
        }
      };
      const menuItemLinks = document.querySelectorAll('li.has-submenu > a');
      const dropdownMenuItemLinks = document.querySelectorAll('li.has-submenu > ul > li > a');

      function findAncestor (el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
      }

    //accessibility for first level navigation
    if(menuItemLinks.length) {
      Array.prototype.forEach.call(menuItemLinks, (el) => {

        let parent = el.parentElement;
        el.addEventListener('focus', function(event) {
          // hideSubmenus(); //TODO not sure if this is needed
          parent.classList.add('open');
          clearTimeout(timer);
        });

        el.addEventListener('touchend', function(event) {
          if(window.innerWidth >= 1140) {
            let allActivePrimaryNav = document.querySelectorAll('.touch-active');

            if(!el.classList.contains('touch-active')) {
              event.preventDefault();
              hideSubmenus();
              const parentNav = findAncestor(el, 'has-submenu');
              parentNav.classList.add('open');
              clearTimeout(timer);
            }
            Array.prototype.forEach.call(allActivePrimaryNav, (el) => {
              el.classList.remove('touch-active')
            })

            el.classList.toggle('touch-active');
          }
        });

        el.addEventListener('keydown', function(event) {
            let key = event.keyCode;
            if (key === 40) {
              event.preventDefault();
              let firstMenuItem = parent.querySelectorAll('ul li')[0].querySelector('a');

              firstMenuItem.focus();
            } else if (key === 9 && !event.shiftKey) {
              let nextNavItem = findAncestor(el, 'has-submenu');
              if(nextNavItem.nextElementSibling !== null) {
                event.preventDefault();
                hideSubmenus();
                nextNavItem.nextElementSibling.querySelector('a').focus();
              } else {
                const btn = document.querySelector('.js-search .btn--search');
                if(btn) {
                  event.preventDefault();
                  btn.focus();
                }
                hideSubmenus();
              }
            } else if(event.shiftKey && event.keyCode == 9) {
              hideSubmenus();
              let prevNavItem = findAncestor(el, 'has-submenu').previousElementSibling;
              if(prevNavItem) {
                event.preventDefault();
                prevNavItem.querySelector('a').focus();

              }
            }

        });
      });
    }

    if(dropdownMenuItemLinks.length) {
      //accessibility using up/down arrows for menu items
      Array.prototype.forEach.call(dropdownMenuItemLinks, (el) => {
        el.addEventListener('keydown', function(event) {
          event.preventDefault();
            let key = event.keyCode;
            let parent = el.parentElement;
            let nextMenuItemLink = parent.nextElementSibling;
            let prevMenuItemLink = parent.previousElementSibling;
            if (key === 40 && nextMenuItemLink ) {

              if(parent.classList.contains('is-lv2')){
                parent.lastElementChild.querySelector('a').focus()
              }else{
                nextMenuItemLink.querySelector('a').focus();
              }
            } else if (key === 38 && prevMenuItemLink) {
              prevMenuItemLink.querySelector('a').focus();
            } else if (key === 9 && !event.shiftKey) {
              let nextNavItem = findAncestor(parent, 'has-submenu');
              hideSubmenus();
              if(nextNavItem.nextElementSibling !== null) {
                nextNavItem.nextElementSibling.querySelector('a').focus();
              }
            } else if(event.shiftKey && event.keyCode == 9) {
              hideSubmenus();
              let prevNavItem = findAncestor(parent, 'has-submenu');
              prevNavItem.previousElementSibling.querySelector('a').focus();
            }

        });
      });
    }

    if(menuItems.length) {
      Array.prototype.forEach.call(menuItems, (el) => {
        const dropdownOpen = document.querySelector('.dropdown__container--search.open') === null,
          parent = findAncestor(el, 'has-submenu');

        if(parent){
          el.classList.add('is-lv2');
        }else{
          el.classList.add('is-lv1');
        }

        el.addEventListener('mouseover', function () {
          if(dropdownOpen) {

            if(parent){
              this.classList.add('open');
              return false;
            }

            hideSubmenus();
            this.classList.add('open');
            clearTimeout(timer);
          }
        });
        // set up mobile nav click event to move to level 2 items
        const level2ToggleEl = el.querySelector('.mobile-sub-toggle');
        level2ToggleEl.addEventListener('click', function (e) {
          const bodyEl = document.querySelector('body');
          const isMobile = bodyEl.className === 'body-container primary-nav-open';
          if (isMobile) {
            e.preventDefault();
            $(level2ToggleEl).toggleClass('open');
          }
          // hideSubmenus();
          const parentList = $(el).closest('li'),
            targetedList = parentList.find('ul');

          parentList.className = 'has-submenu open';

          targetedList.first().toggle('open');
          clearTimeout(timer);
        });

        el.addEventListener('mouseleave', (event) => {
          const hasThirdLevel = el.querySelector('.has-submenu');

          if(el.classList.contains('is-lv2')){
            el.classList.remove('open');
          }
          if(hasThirdLevel){
            el.classList.remove('open');
          }else{
            timer = setTimeout(hideSubmenus, 500);
          }
        });
        const btn = '<button><span><span class="visually-hidden">show submenu</span></span></button>';
        const topLevelLink = el.querySelector('a');
        topLevelLink.innerHTML = `${topLevelLink.innerHTML} ${btn}`;
        el.querySelector('a button').addEventListener('click', function (e) {
          e.preventDefault();
          if (this.parentNode.parentNode.className === 'has-submenu') {
            hideSubmenus();
            this.parentNode.parentNode.classList.add('open');
            this.parentNode.setAttribute('aria-expanded', 'true');
            this.querySelector('.visually-hidden').innerText = 'hide submenu';
          } else {
            this.parentNode.parentNode.classList.remove('open');
            this.parentNode.setAttribute('aria-expanded', 'false');
            this.querySelector('.visually-hidden').innerText = 'show submenu';
          }
        });
      });
    }


    // mobile menu
    const menuToggleEl = document.querySelector('#js-menu-toggle');
    if (menuToggleEl) {
      menuToggleEl.addEventListener('click', () => {
        const bodyEl = document.querySelector('body');
        bodyEl.classList.toggle('primary-nav-open');
      });
    }

    //hide search bar if not included
    let primaryNav = document.querySelector(".primary-nav");
    if( !document.querySelectorAll(".primary-nav .mobile-btn").length && primaryNav) {
      primaryNav.classList.add('no-search')
    }
  }

})
};



$.initialisePrimaryNav();
